export const VENDOR_SELECTION_ONLY_MODULES = new Set(['complispace', 'sentral']);

export const DEFAULT_SUBSET_ATTRIBUTE_KEYS = ['sub_long', 'sub_short', 'sub_type', 'originalType'];
